import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
});

function UnderConstruction(props) {
    const { classes } = props;

    return (
        <div>
            <Paper className={classes.root} elevation={1}>
                <Typography variant="h5" component="h3">
                    Under Construction.
                </Typography>
                <Typography component="p">
                    This functionality is not ready yet.
                </Typography>
            </Paper>
        </div>
    );
}

UnderConstruction.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UnderConstruction);
